import { useContext } from "react";
import { DialogContext } from "../contexts/dialogContext";

export const useDialog = () => {
  const context = useContext(DialogContext);

  return context;
};
